import type { JSX } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { InstanceProvider } from './frame/InstanceContext';
import { AppShell } from './frame/AppShell';
import { CorpusSignIn } from './auth/CorpusSignIn';
import { LogoutPage } from './auth/LogoutPage';
import { DocumentListPage } from './reading/DocumentListPage';
import { DocumentPage } from './reading/DocumentPage';
import { ImportPage } from './import/ImportPage';

export function App(): JSX.Element {
  return (
    <InstanceProvider>
      <Routes>
        {/* Unauthenticated auth flow — no app frame. The shared <LoginScreen>
            (CorpusSignIn) owns both the email and code steps, so there is no
            longer a separate /auth/verify route. */}
        <Route path="auth/login" element={<CorpusSignIn />} />
        <Route path="auth/logout" element={<LogoutPage />} />

        {/* Authenticated app — AppShell gates on /api/auth/me. */}
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="read" replace />} />
          <Route path="read" element={<DocumentListPage />} />
          <Route path="read/:id" element={<DocumentPage />} />
          <Route path="import" element={<ImportPage />} />
        </Route>
      </Routes>
    </InstanceProvider>
  );
}
